<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? '新增' : '删除'" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
            <el-form-item prop="title" label="任务名称">
                <el-input v-model="dataForm.title" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="content" label="任务详情">
                <tinymce v-model="dataForm.content" :height="300"></tinymce>
            </el-form-item>
            <el-form-item prop="pubDate" label="任务期限">
                <el-date-picker v-model="dataForm.pubDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"></el-date-picker>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'
    export default {
        data () {
            return {
                visible: false,
                dataForm: {
                    id: '',
                    title: '',
                    content: '',
                    pubDate: ''
                }
            }
        },
        computed: {
            dataRule () {
                return {
                    title: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ],
                    content: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ],
                    pubDate: [
                        { required: true, message: '请输入', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            init () {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if (this.dataForm.id) {
                        this.getInfo()
                    }
                })
            },
            // 获取信息
            getInfo () {
                this.$http.get(`/demo/news/${this.dataForm.id}`).then(({ data: res }) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = res.data
                }).catch(() => {})
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http[!this.dataForm.id ? 'post' : 'put'](
                        '/demo/news',
                        this.dataForm,
                        { headers: { 'content-type': 'application/x-www-form-urlencoded' } }
                    ).then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {})
                })
            }, 1000, { 'leading': true, 'trailing': false })
        }
    }
</script>
